export default class Viewport
{
    /**
     * @param {HTMLElement} elem
     * @returns {boolean}
     */
    elementRightSiteOutOfViewport(elem) {
        const bounding = elem.getBoundingClientRect();
        return (bounding.right > (window.innerWidth || document.documentElement.clientWidth));
    }
}
